module.exports = __webpack_public_path__ + "static/media/4.4c2a811b.jpg";